<template>
    <div v-show="this.active">
        <div class="flex flex-col text-black" :class="{'w-full p-4': active}">

            <!-- Ladeanimation -->
            <transition name="bounce">
                <div v-if="isLoading" class="flex items-center justify-center py-6">
                    <loading-dots></loading-dots>
                </div>
            </transition>

            <!-- Quiz-Bereich -->
            <div v-if="!isLoading && satzhilfeResult" class="w-full">



                <!-- Aktuelle Frage -->
                <div v-if="!allCompleted"
                     class="py-3">

                    <!-- Fortschritts-Dots -->
                    <div class="flex items-center gap-2 mb-3">
                        
                                        <!-- Klick-Hinweis -->
                    <div v-if="!stufeCompleted && !feedbackText"
                         class="inline-flex items-center gap-2 mr-8 py-1.5 rounded-full text-grey-500 text-xs">
                        <i class="fas fa-hand-pointer text-xs"></i>
                        Klicke oben auf das richtige Wort
                    </div>
                        <span v-for="s in 3" :key="s"
                              class="w-2 h-2 rounded-full transition-colors duration-300"
                              :class="s <= currentStufe ? stufeDotClass : 'bg-grey-300'"></span>
                        <span class="text-xs text-grey-500 ml-1">{{ currentStufe }}/3</span>
                        <span v-if="attempts > 0 && !stufeCompleted"
                              class="text-xs text-grey-400 ml-auto">Versuch {{ attempts }}/{{ maxAttempts }}</span>

                    </div>

                    <!-- Frage -->
                    <p class="text-lg leading-relaxed mb-3"
                       v-html="renderLatinText(currentStufeData.question)"
                       @mouseover="handleLatinRefHover"
                       @mouseout="handleLatinRefLeave">
                    </p>

          

                    <!-- Feedback -->
                    <transition name="slideY">
                        <div v-if="feedbackText"
                             class="mt-3 flex items-start gap-2 text-base text-grey-700">
                            <i class="fas mt-1"
                               :class="{
                                   'fa-check text-success': feedbackType === 'correct',
                                   'fa-times text-danger': feedbackType === 'incorrect' || feedbackType === 'revealed'
                               }"></i>
                            <span v-html="renderLatinText(feedbackText)"
                                  @mouseover="handleLatinRefHover"
                                  @mouseout="handleLatinRefLeave"></span>
                        </div>
                    </transition>

                    <!-- Weiter-Button -->
                    <div v-if="stufeCompleted" class="mt-4 flex justify-end">
                        <button v-if="currentStufe < 3"
                                @click="advanceToNextStufe"
                                class="px-4 py-2 bg-secondary-500 text-white font-bold rounded hover:bg-secondary-600 transition-colors">
                            Nächste Frage &rarr;
                        </button>
                        <button v-else
                                @click="showMerkeBox"
                                class="px-4 py-2 bg-secondary-500 text-white font-bold rounded hover:bg-secondary-600 transition-colors">
                            Zusammenfassung &rarr;
                        </button>
                    </div>
                </div>

                <!-- Merke-Box -->
                <transition name="slideY">
                    <div v-if="allCompleted"
                         class="satzhilfe-merke p-4 bg-primary-50 rounded-lg">
                        <div class="flex items-center mb-3">
                            <hermeneus-icon name="hib-merkur-hinweise" height="32" width="32" :preserveColors="true" class="mr-2 flex-shrink-0"></hermeneus-icon>
                            <span class="text-base font-bold text-secondary-700 uppercase tracking-wide">Merke</span>
                        </div>
                        <ol class="list-decimal list-inside space-y-2 text-lg leading-relaxed"
                            @mouseover="handleLatinRefHover"
                            @mouseout="handleLatinRefLeave">
                            <li v-html="renderLatinText(satzhilfeResult.stufe1.merke)"></li>
                            <li v-html="renderLatinText(satzhilfeResult.stufe2.merke)"></li>
                            <li v-html="renderLatinText(satzhilfeResult.stufe3.merke)"></li>
                        </ol>
                    </div>
                </transition>
            </div>

            <!-- Fehlermeldung -->
            <div v-if="errorMessage" class="px-3 py-2 bg-danger-light text-danger-dark rounded text-sm">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
import {haxiosAPIClient} from "@js/haxios/haxios.js";

export default {
    name: "reader-sentence-viewer-tool-satzhilfe",
    components: {},
    props: {
        name: {required: true},
        satzhilfeMode: {type: String, default: 'dynamic'},
    },
    data: function () {
        return {
            active: this.$parent.$parent.Tool_Satzhilfe_Active,
            btn_img_src: '/img/svg/hib-merkur-hinweise.svg',
            btn_hover_classes: '',
            btn_disabled_if: false,
            btn_hidden_if: false,
            btn_infobar_html: 'Satzhilfe',
            btn_html: 'Satzhilfe',
            satzhilfeResult: null,
            currentStufe: 1,
            attempts: 0,
            maxAttempts: 3,
            feedbackText: '',
            feedbackType: '',
            stufeCompleted: false,
            allCompleted: false,
            isLoading: false,
            errorMessage: '',
            satzhilfeActive: false,
            boundHandleWordClick: null,
        }
    },
    computed: {
        Sentence: function () {
            return this.$parent.$parent.$parent.Sentences.find(
                Sentence => parseInt(Sentence.sentence_id) === parseInt(this.$parent.$parent.$parent.SentenceActiveID)
            );
        },
        SatzhilfeUnavailable: function () {
            return !this.Sentence;
        },
        sentenceContainer: function () {
            return this.$parent.$parent.$refs.sentence_html;
        },
        currentStufeData: function () {
            if (!this.satzhilfeResult) return null;
            return this.satzhilfeResult['stufe' + this.currentStufe];
        },
        stufeBorderClass: function () {
            return {
                1: 'border-primary-500',
                2: 'border-secondary-500',
                3: 'border-primary-700'
            }[this.currentStufe] || 'border-primary-500';
        },
        stufeDotClass: function () {
            return {
                1: 'bg-primary-500',
                2: 'bg-secondary-500',
                3: 'bg-primary-700'
            }[this.currentStufe] || 'bg-primary-500';
        }
    },
    methods: {
        async activate() {
            if (this.satzhilfeActive && this.satzhilfeResult) {
                // Quiz schon geladen - Handler wieder aktivieren
                this.$parent.$parent.unregisterAnalysis();
                this.registerSatzhilfeClickHandlers();
                this.showInteractiveBanner();
            } else if (!this.satzhilfeResult && !this.isLoading) {
                if (this.satzhilfeMode === 'preset') {
                    this.loadPresetSatzhilfe();
                } else {
                    this.getSatzhilfe();
                }
            }
        },

        deactivate() {
            this.unregisterSatzhilfeClickHandlers();
            this.$parent.$parent.registerAnalysis();
            this.clearHighlights();
            this.clearLatinRefHighlights();
            this.removeInteractiveBanner();
            this.satzhilfeActive = false;
        },

        endSatzhilfe() {
            this.deactivate();
            this.satzhilfeResult = null;
            this.allCompleted = false;
            this.feedbackText = '';
            this.feedbackType = '';
        },

        async getSatzhilfe() {
            this.isLoading = true;
            this.errorMessage = '';
            this.satzhilfeResult = null;
            this.currentStufe = 1;
            this.attempts = 0;
            this.feedbackText = '';
            this.feedbackType = '';
            this.stufeCompleted = false;
            this.allCompleted = false;

            try {
                const sentenceXml = this.sentenceContainer.innerHTML;
                const sentenceString = await this.getSentenceString();
                const context = await this.getTextpartString();

                const response = await haxiosAPIClient.post('/modules/satzhilfe/get-satzhilfe', {
                    sentenceXml,
                    sentenceString,
                    context
                });

                this.satzhilfeResult = response.data.result;
                this.satzhilfeActive = true;

                this.$parent.$parent.unregisterAnalysis();
                this.registerSatzhilfeClickHandlers();

                this.showInteractiveBanner();
            } catch (error) {
                console.error('Satzhilfe-Fehler:', error);
                if (error.response && error.response.status === 401) {
                    this.errorMessage = 'Nicht authentifiziert. Bitte erneut anmelden.';
                } else if (error.response && error.response.status === 422) {
                    this.errorMessage = 'Ungültige Anfrage.';
                } else {
                    this.errorMessage = 'Die Satzhilfe konnte nicht geladen werden. Bitte versuche es erneut.';
                }
            } finally {
                this.isLoading = false;
            }
        },

        loadPresetSatzhilfe() {
            this.satzhilfeResult = null;
            this.currentStufe = 1;
            this.attempts = 0;
            this.feedbackText = '';
            this.feedbackType = '';
            this.stufeCompleted = false;
            this.allCompleted = false;
            this.errorMessage = '';

            const sentenceId = this.Sentence ? this.Sentence.sentence_id : null;
            if (!sentenceId) {
                this.errorMessage = 'Kein Satz ausgewählt.';
                return;
            }

            // Satzhilfe aus vorextrahierten Textparts lesen
            const satzhilfeMap = this.$parent.$parent.$parent.Textparts.Satzhilfe;
            const foundData = satzhilfeMap ? satzhilfeMap[sentenceId] : null;

            if (foundData) {
                this.satzhilfeResult = foundData;
                this.satzhilfeActive = true;
                this.$parent.$parent.unregisterAnalysis();
                this.registerSatzhilfeClickHandlers();
                this.showInteractiveBanner();
            } else {
                this.errorMessage = 'Für diesen Satz ist keine voreingestellte Satzhilfe verfügbar.';
            }
        },

        async getSentenceString() {
            return this.Sentence.sentence_string;
        },

        async getTextpartString() {
            return this.$parent.$parent.$parent.Textparts.TextContent;
        },

        /**
         * Rendert Text mit lateinischen Wort-Referenzen.
         * Format: *wort:w_id* oder *wort:id1,id2* => interaktiver Span mit Hover-Highlight
         * Format: *wort* (ohne ID) => nur Serifen-Styling
         */
        renderLatinText(text) {
            if (!text) return '';
            let escaped = this.escapeHtml(text);
            // *wort:id* oder *wort:id1,id2* => interaktiver Span mit data-w-ids
            escaped = escaped.replace(
                /\*([\p{L}\p{M}\s]+):([0-9,]+)\*/gu,
                '<span class="satzhilfe-latin-ref font-serif font-bold text-secondary-600 cursor-pointer border-b border-dashed border-secondary-400" data-w-ids="$2">$1</span>'
            );
            // *wort* ohne ID => nur Serifen-Styling
            escaped = escaped.replace(
                /\*([\p{L}\p{M}]+)\*/gu,
                '<span class="font-serif font-bold">$1</span>'
            );
            return escaped;
        },

        escapeHtml(str) {
            const div = document.createElement('div');
            div.appendChild(document.createTextNode(str));
            return div.innerHTML;
        },

        /**
         * Hover auf lateinische Referenz => Wort im Satz highlighten
         */
        handleLatinRefHover(event) {
            const refEl = event.target.closest('.satzhilfe-latin-ref');
            if (!refEl) return;
            const wIds = refEl.getAttribute('data-w-ids');
            if (!wIds) return;
            this.highlightWordsSecondary(wIds.split(','));
        },

        handleLatinRefLeave(event) {
            const refEl = event.target.closest('.satzhilfe-latin-ref');
            if (!refEl) return;
            this.clearLatinRefHighlights();
        },

        /**
         * Highlightet Woerter im Satz in Secondary-Farbe
         */
        highlightWordsSecondary(wIds) {
            if (!this.sentenceContainer) return;
            for (const wId of wIds) {
                const wordEl = this.sentenceContainer.querySelector(`tei-w[w_id="${wId.trim()}"]`);
                if (wordEl) {
                    wordEl.classList.add('satzhilfe-ref-highlight');
                }
            }
        },

        clearLatinRefHighlights() {
            if (!this.sentenceContainer) return;
            const highlighted = this.sentenceContainer.querySelectorAll('.satzhilfe-ref-highlight');
            highlighted.forEach(el => el.classList.remove('satzhilfe-ref-highlight'));
        },

        registerSatzhilfeClickHandlers() {
            if (!this.sentenceContainer) return;
            this.boundHandleWordClick = this.handleWordClick.bind(this);
            const words = this.sentenceContainer.querySelectorAll('tei-w');
            words.forEach(word => {
                word.addEventListener('click', this.boundHandleWordClick, false);
                word.classList.add('satzhilfe-clickable');
            });
        },

        unregisterSatzhilfeClickHandlers() {
            if (!this.sentenceContainer || !this.boundHandleWordClick) return;
            const words = this.sentenceContainer.querySelectorAll('tei-w');
            words.forEach(word => {
                word.removeEventListener('click', this.boundHandleWordClick, false);
                word.classList.remove('satzhilfe-clickable');
            });
        },

        handleWordClick(event) {
            if (this.stufeCompleted) return;

            const wordEl = event.currentTarget;
            const wId = wordEl.getAttribute('w_id');
            if (!wId || !this.currentStufeData) return;

            const correctIds = (this.currentStufeData.correct_w_ids || []).map(String);

            if (correctIds.includes(wId)) {
                wordEl.classList.add('satzhilfe-correct');
                this.highlightCorrectWords();
                const feedback = this.currentStufeData.feedback?.[wId] || 'Richtig!';
                this.showFeedback('correct', feedback);
                this.stufeCompleted = true;
            } else {
                this.attempts++;
                wordEl.classList.add('satzhilfe-incorrect');
                setTimeout(() => wordEl.classList.remove('satzhilfe-incorrect'), 600);

                if (this.attempts >= this.maxAttempts) {
                    this.revealCorrectAnswer();
                } else {
                    this.showFeedback('incorrect', this.currentStufeData.feedback_incorrect || 'Nicht ganz, versuche es nochmal.');
                }
            }
        },

        showFeedback(type, text) {
            this.feedbackType = type;
            this.feedbackText = text;
        },

        highlightCorrectWords() {
            if (!this.sentenceContainer || !this.currentStufeData) return;
            const correctIds = this.currentStufeData.correct_w_ids || [];
            for (const wId of correctIds) {
                const wordEl = this.sentenceContainer.querySelector(`tei-w[w_id="${wId}"]`);
                if (wordEl) {
                    wordEl.classList.add('satzhilfe-correct');
                }
            }
        },

        revealCorrectAnswer() {
            this.highlightCorrectWords();
            const firstCorrectId = this.currentStufeData.correct_w_ids?.[0];
            const feedback = this.currentStufeData.feedback?.[firstCorrectId] || 'Das war die richtige Antwort.';
            this.showFeedback('revealed', feedback);
            this.stufeCompleted = true;
        },

        advanceToNextStufe() {
            this.clearHighlights();
            this.currentStufe++;
            this.attempts = 0;
            this.feedbackText = '';
            this.feedbackType = '';
            this.stufeCompleted = false;
        },

        showMerkeBox() {
            this.clearHighlights();
            this.allCompleted = true;
            this.unregisterSatzhilfeClickHandlers();
            this.$parent.$parent.registerAnalysis();
            this.removeInteractiveBanner();
            this.satzhilfeActive = false;
        },

        showInteractiveBanner() {
            if (!this.sentenceContainer) return;
            // Bereits vorhanden?
            if (this.sentenceContainer.parentNode.querySelector('.satzhilfe-interactive-banner')) return;

            // Wrapper um sentence_container, damit Banner + Satz vertikal gestapelt werden
            const wrapper = document.createElement('div');
            wrapper.className = 'satzhilfe-interactive-wrapper w-full';

            const banner = document.createElement('div');
            banner.className = 'satzhilfe-interactive-banner flex items-center gap-2 px-3 py-1.5 text-secondary-300 text-base font-bold';
            banner.innerHTML = '<i class="fas fa-mouse-pointer"></i> Interaktiver Modus';

            this.sentenceContainer.parentNode.insertBefore(wrapper, this.sentenceContainer);
            wrapper.appendChild(banner);
            wrapper.appendChild(this.sentenceContainer);
        },

        removeInteractiveBanner() {
            if (!this.sentenceContainer) return;
            const wrapper = this.sentenceContainer.closest('.satzhilfe-interactive-wrapper');
            if (!wrapper) return;
            // sentence_container zurück an ursprüngliche Position
            wrapper.parentNode.insertBefore(this.sentenceContainer, wrapper);
            wrapper.remove();
        },

        clearHighlights() {
            if (!this.sentenceContainer) return;
            const highlighted = this.sentenceContainer.querySelectorAll('.satzhilfe-correct, .satzhilfe-incorrect');
            highlighted.forEach(el => {
                el.classList.remove('satzhilfe-correct');
                el.classList.remove('satzhilfe-incorrect');
            });
        }
    }
}
</script>

<style>
/* Alpha-Badge nur am Toolbar-Button, nicht am Inhaltsbereich */
.reader__workspace__analysis--sentence__toolbar--item.alpha-feature::before {
    display: none;
}

/* Richtiges Wort - gruen (nur Hintergrund, keine Border um Zeilenhoehe stabil zu halten) */
.satzhilfe-correct {
    background-color: rgba(92, 184, 92, 0.25);
    border-radius: 2px;
    transition: background-color 0.3s ease;
}

/* Falsches Wort - rotes Flash */
.satzhilfe-incorrect {
    animation: satzhilfe-flash-red 0.6s ease;
}

@keyframes satzhilfe-flash-red {
    0% { background-color: transparent; }
    20% { background-color: rgba(217, 83, 59, 0.25); }
    100% { background-color: transparent; }
}

/* Hover-Highlight fuer lat. Referenzen im Satz - secondary/rot (nur Hintergrund) */
.satzhilfe-ref-highlight {
    background-color: rgba(178, 46, 47, 0.18);
    border-radius: 2px;
    transition: background-color 0.2s ease;
}

/* Klickbare Woerter im Quiz-Modus */
.satzhilfe-clickable {
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.satzhilfe-clickable:hover {
    color: #B22E2F !important;
    transition: all 0.3s ease-out;
    font-weight: normal !important;
}

/* Lateinische Referenzen im Text - hover */
.satzhilfe-latin-ref:hover {
    background-color: rgba(178, 46, 47, 0.08);
    border-radius: 2px;
}

/* Icon-Sizing */
.tool-satzhilfe__btn {
    transition: all 0.3s ease-in-out;
}

.tool-satzhilfe__btn .hermeneus-icon svg,
.satzhilfe-merke .hermeneus-icon svg {
    width: 100%;
    height: 100%;
}

/* Animationen */
.bounce-enter-active {
    animation: bounce-in 0.3s ease-in-out;
}

.bounce-leave-active {
    animation: bounce-in 0.25s reverse;
}

@keyframes bounce-in {
    0% { opacity: 0; transform: scale(0.3); }
    50% { opacity: 0.9; transform: scale(1.1); }
    80% { opacity: 1; transform: scale(0.89); }
    100% { opacity: 1; transform: scale(1); }
}

.slideY-enter-active {
    animation: slideY-in 0.3s ease-out;
}

.slideY-leave-active {
    animation: slideY-in 0.2s reverse;
}

@keyframes slideY-in {
    0% { opacity: 0; transform: translateY(-10px); }
    100% { opacity: 1; transform: translateY(0); }
}

button[disabled] {
    opacity: 0.5;
}
</style>
